export const titleData = [
  {
    name: "修改个人信息",
    push: "/register",
    type: "editUser",
  },
  {
    name: "修改绑定手机",
    push: "/editPhone",
    type: "editPhone",
  },
  {
    name: "修改密码",
    push: "/editPaswed",
    type: "editPaswed",
  },
  {
    name: "退出登录",
    type: "editCoal",
  },
];
